import { Route, Routes } from '@angular/router';
import { EulaGuard } from '@core/guards/eula.guard';
import { AuthGuardService } from '@rockwell-automation-inc/service';

import { ShellComponent } from './shell.component';

/**
 * Provides helper methods to create routes.
 */
export class Shell {
  /**
   * Creates routes using the shell component and authentication.
   * @param routes The routes to add.
   * @return The new route using shell as the base.
   */
  static childRoutes(routes: Routes): Route {
    return {
      canActivate: [AuthGuardService],
      canActivateChild: [EulaGuard],
      children: routes,
      component: ShellComponent,
      path: '',
    };
  }
}
